import * as wjcCore from '@mescius/wijmo';
import * as wjGridFilter from '@mescius/wijmo.grid.filter';
import * as wjcGrid from '@mescius/wijmo.grid';

'use strict';

import {ViewChild, Component, AfterViewInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {HttpClient, HttpEventType, HttpRequest} from "@angular/common/http";
import {DomSanitizer} from '@angular/platform-browser';
import {Store} from "@ngrx/store";
import {ToasterService} from "angular2-toaster";
import {TranslocoService} from '@jsverse/transloco';
import {ActivePromotionConfig} from "../config/active-promotion.config";
import {asOrientDate, isOrientDate, DataService, OrientDBCollectionView} from "@cosbeni/database";
import * as uuid from "uuid";
import {Observable} from 'rxjs';
@Component({
    standalone: false,
    selector: 'cj-admin-news',
    templateUrl: 'news-management.component.html',
})

export class NewsManagementComponent implements AfterViewInit {
    readonly: Boolean = true;
    @ViewChild('newsGrid') historyGrid: wjcGrid.FlexGrid;
    filter: wjGridFilter.FlexGridFilter;
    news: any = {};
    newses: OrientDBCollectionView;
    mode: string = "view";
    tinymceConfig: any = {
        plugins:
            'advlist autolink lists link image charmap preview anchor searchreplace visualblocks code fullscreen insertdatetime media table code help wordcount',
        toolbar:
            'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify |  bullist numlist outdent indent | removeformat | help',
        language: 'ja' ,
        language_url: 'assets/tinymce/langs/ja.js'
    };

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, private route: ActivatedRoute, private http: HttpClient,private sanitized: DomSanitizer, private transloco: TranslocoService) {
        this.newses = new OrientDBCollectionView(dataService, ActivePromotionConfig.DATABASE, "SELECT FROM DA_News", "DA_News", "", 0, 100, true, true, false)
        this.newses.url = ActivePromotionConfig.SERVER_URL;
        this.newses.tokenName = ActivePromotionConfig.DATABASE + "_token";
        this.newses.fetchPlan = "*:1";
        this.createNew();
        this.mode = "view";
    }

    ngAfterViewInit() {
        this.newses.filterOnServer = true;
        this.newses.currentChanged.addHandler(this.onCurrentChanged, this);
        this.newses.itemsSourceFunction = function (items: any[]) {
            for (let item of items) {
                if (isOrientDate(item.historyDate)) {
                    item.historyDate = asOrientDate(item.historyDate);
                }
            }
            return items;
        }
    }

    onCurrentChanged(sender: any, args: wjcCore.EventArgs): void {
        if (this.newses.currentItem != null && this.mode == "view") {
            this.news = Object.assign({},this.newses.currentItem);
        }
    }

    createNew(): void {
        this.mode = "edit";
        this.news = {
            "@class": "DA_News",
            "@rid": "#-1:-1",
            newsDate: new Date(),
            public: false,
            subject: "",
            content: "",
            uuid: uuid.v4().split("-").join("")
        }
    }

    editNews(): void {
        this.mode = "edit";
        if (this.newses.currentItem != null) {
            this.news = Object.assign({}, this.newses.currentItem);
        }
    }

    cancelNews(): void {
        this.mode = "view";
        if (this.newses.currentItem != null) {
            this.news = Object.assign({}, this.newses.currentItem);
        }
    }

    saveNews(): void {
        this.saveNews$().subscribe((response: any) => {
                this.toasterService.pop('info', this.transloco.translate('common.save'), this.transloco.translate('admin.saved_message'));
                this.dataService.query({
                    sql: "SELECT FROM DA_News WHERE uuid = '" + this.news.uuid + "'",
                    count: "SELECT FROM DA_News WHERE uuid = '" + this.news.uuid + "'",
                    fetchPlan: "*:1",
                }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                    if (data.results.length == 1) {
                        this.news = data.results[0];
                        if (isOrientDate(this.news.newsDate)) {
                            this.news.newsDate = asOrientDate(this.news.newsDate);
                        }
                    }
                    if (wjcCore.isObject(this.newses.currentItem) && this.newses.currentItem.uuid == this.news.uuid) {
                        let newsesArray = this.newses.sourceCollection;
                        let index = newsesArray.indexOf(this.newses.currentItem);
                        this.newses.sourceCollection[index] = this.news;
                        this.newses.refresh();
                        this.mode = "view";
                    }
                })
            },
            (error: any) => {
                this.toasterService.pop('error', this.transloco.translate('common.save'), this.transloco.translate('admin.failed_message'));
            }
        )
    }

    saveNews$(): Observable<any> {
        console.log(this.news);
        let news = Object.assign({}, this.news);
        if (wjcCore.isDate(news.newsDate)) {
            news.newsDate = wjcCore.Globalize.formatDate(news.newsDate, 'yyyy-MM-dd HH:mm:ss');
        }
        let sql = "BEGIN\n"
        let mapItem: any[] = [];
        Object.entries(news).forEach(([key, value]) => {
            if (!key.startsWith("@") && value != null) {
                if (wjcCore.isString(value)) {
                    let v: string = value;
                    v = v.replace(/\\/g, "\\\\");
                    v = v.replace(/\n/g, "\\n");
                    v = v.replace(/\t/g, "\\t");
                    v = v.replace(/'/g, "\\'");
                    v = v.replace(/"/g, '\\"');
                    value = v;
                    mapItem.push(key + "='" + value + "'")
                }
                if (wjcCore.isBoolean(value)) {
                    mapItem.push(key + "=" + (value ? "true" : "false"));
                }
            }
        });
        if (news['@rid'] == "#-1:-1") {
            sql = sql + "let news = INSERT INTO DA_News SET " + mapItem.join(",") + " return $current\n";
        } else {
            sql = sql + "UPDATE DA_News SET " + mapItem.join(",") + " WHERE @rid = " + this.news['@rid'] + "\n";
        }
        sql = sql + "COMMIT RETRY 100\n";
        return this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL);
    }

}

